import React, { useState } from 'react';
import { Box, Button, Checkbox, DialogContentText, FormControlLabel } from '@mui/material';

/**
 * Recovery codes shown once, with copy and download, and a tick box the person must
 * check before carrying on (1 Oct 2026). Used at setup and when making a new set.
 */
export default function RecoveryCodesPanel({ codes, saved, onSavedChange }) {
  const [copied, setCopied] = useState(false);
  const text = `AIMHI recovery codes (each works once)\n\n${codes.join('\n')}\n`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      setCopied(false);
    }
  };

  const download = () => {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'aimhi-recovery-codes.txt';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <Box>
      <DialogContentText sx={{ mb: 1 }}>
        Save these recovery codes somewhere safe, such as a password manager. Each one lets you sign in once if you
        don't have your phone. They will not be shown again.
      </DialogContentText>
      <Box sx={{ fontFamily: 'monospace', bgcolor: 'action.hover', p: 2, borderRadius: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 1 }}>
        {codes.map(c => <span key={c}>{c}</span>)}
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <Button size="small" variant="outlined" onClick={copy}>{copied ? 'Copied' : 'Copy'}</Button>
        <Button size="small" variant="outlined" onClick={download}>Download</Button>
      </Box>
      <FormControlLabel
        control={<Checkbox id="mfa-codes-saved" checked={saved} onChange={e => onSavedChange(e.target.checked)} />}
        label="I have saved my recovery codes"
      />
    </Box>
  );
}
